export const FILTER = function (text, length, clamp) {
  clamp = clamp || '...'
  let node = document.createElement('div')
  node.innerHTML = text
  let content = node.textContent
  return content.length > length ? content.slice(0, length).trim() + clamp : content
}

export default {
  install (Vue) {
    Vue.filter('truncate', FILTER)
  }
}
